<template>
  <div id="app">
    <AppNavbar @show-login="openLoginModal" />
    <!-- <LanguageBanner /> -->
    <router-view />
    <AppContact />
    <AppFooter />
    <LoginModal
      :visible="showLoginModal"
      @close="closeLoginModal"
    />
  </div>
</template>

<script>
import AppNavbar from "./components/AppNavbar.vue";
import AppContact from "./components/AppContact.vue";
import AppFooter from "./components/AppFooter.vue";
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import LoginModal from './components/LoginModal.vue';
// import LanguageBanner from "@/components/LanguageBanner.vue";

export default {
  name: "App",
  components: {
    AppNavbar,
    AppContact,
    AppFooter,
    LoginModal,
   // LanguageBanner,
  },
  data() {
    return {
      showLoginModal: false,
    };
  },
  methods: {
    openLoginModal() {
      this.showLoginModal = true;
    },
    closeLoginModal() {
      this.showLoginModal = false;
    }
  },
  setup() {
    const { locale } = useI18n();
    watch(
      locale,
      (newLang) => {
        document.documentElement.lang = newLang;
      },
      { immediate: true }
    );
  },
};
</script>

<style>
#app {
  /* margin-top: 0;  */
  margin-top: -20px; /* was -20px, remove this hack */
  padding: 0 !important;
  font-family: "Montserrat", sans-serif;
  color: #707070;
  background-color: #fff;
  overflow-x: hidden !important;
  border: 0 !important;
  min-height: 100vh;
  /* REMOVE FLEX */
}

.router-view {
  flex: 1;
  padding-bottom: 60px;
  padding-top: 80px !important;
}
</style>
